var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowActiveDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "14px",
    viewBox: "0 0 10 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3C32DC0C-AE7E-4B16-BFDF-926628D8871B_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaardid---Expanded",
    transform: "translate(-987.000000, -190.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(0.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(208.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(780.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Arrow-Down",
    transform: "translate(4.000000, 8.000000) rotate(180.000000) translate(-4.000000, -8.000000) translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L4,12",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    points: "8 3.6 4 1.45572443e-12 0 3.6"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowActiveDown);
export default __webpack_public_path__ + "static/media/Icon_Arrow_Active-Down.01abc7b26fde4504454c24cd15408bc7.svg";
export { ForwardRef as ReactComponent };